import { FC, useCallback } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'
import { RowButtons } from 'partner360/components/rowButtons/RowButtons'

import { useCurrencies } from './hooks/useCurrencies'
import { useCurrencyRestriction } from './hooks/useCurrencyRestriction'
import { ICurrenciesButtonsProps } from './models/currenciesButtonsProps'
import { CURRENCY_TRANSLATION_KEYS } from './translations'

export const CurrenciesButtons: FC<ICurrenciesButtonsProps> = ({
  size,
  isDisabled = false,
  disabledTooltip,
  isIgnoreMultiLocalCurrencies = false,
}) => {
  const { activeCurrency, availableCurrencies, setCurrency } = useCurrencies()
  const { currency, isMultiLocalCurrencyLocked, changeCurrency } = useCurrencyRestriction(
    activeCurrency,
    setCurrency,
    isIgnoreMultiLocalCurrencies
  )
  const isControlDisabled = isDisabled || isMultiLocalCurrencyLocked
  const tooltip = isMultiLocalCurrencyLocked ? (
    <Translation text={CURRENCY_TRANSLATION_KEYS.multipleLocalCurrencies} />
  ) : (
    disabledTooltip
  )
  const handleCurrencyChange = useCallback(
    (value: string) => {
      if (!isControlDisabled) changeCurrency(value)
    },
    [changeCurrency, isControlDisabled]
  )

  const control = (
    <RowButtons
      generateTranslationKey={(value) => value}
      disableOptionTranslation
      value={currency}
      options={
        isMultiLocalCurrencyLocked && !availableCurrencies.includes('USD')
          ? ['USD', ...availableCurrencies]
          : availableCurrencies
      }
      onOptionClick={handleCurrencyChange}
      isDisabled={isControlDisabled}
      size={size}
    />
  )

  return isControlDisabled && tooltip ? (
    <Tooltip inline tipContent={() => <>{tooltip}</>}>
      {control}
    </Tooltip>
  ) : (
    control
  )
}
